import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaExclamationTriangle, FaPlus, FaMinus } from 'react-icons/fa';

const ProjectConfirmModal = ({
    show,
    onHide,
    onConfirm,
    loading = false,
    type = 'remove', // 'add' or 'remove'
    projectCount = 0
}) => {

    const handleConfirm = async () => {
        try {
            await onConfirm();
            onHide();
        } catch (error) {
            console.error('Error in project operation:', error);
        }
    };

    const isRemove = type === 'remove';
    const icon = isRemove ? <FaMinus /> : <FaPlus />;
    const actionCapitalized = isRemove ? 'Remover' : 'Adicionar';
    const color = isRemove ? '#dc3545' : '#28a745';

    return (
        <Modal show={show} onHide={onHide} size="md" centered>
            {/* Header with alert icon */}
            <Modal.Header className='bg-gradient-to-r from-slate-700 to-slate-600 text-white px-6 py-4 flex items-center' style={{
                backgroundColor: '#6c757d',
                color: 'white',
                padding: '12px 20px',
                borderRadius: '8px 8px 0 0',
                marginBottom: '0',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
            }}>
                <span style={{ fontWeight: 'bold' }}>Confirmação</span>
                {isRemove ? <FaExclamationTriangle /> : icon}
            </Modal.Header>

            <Modal.Body style={{ padding: '30px', textAlign: 'center' }}>
                {/* Confirmation message */}
                <div style={{ marginBottom: '25px', lineHeight: '1.6' }}>
                    <p style={{ margin: '0 0 10px 0', fontSize: '16px' }}>
                        {isRemove ? (
                            <>
                                Tem certeza de que deseja <strong style={{ color: color }}>remover {projectCount} projeto(s)</strong> da análise atual?
                                <br /><br />
                                Esta ação irá recalcular todos os resultados sem os projetos selecionados.
                            </>
                        ) : (
                            <>
                                Deseja <strong style={{ color: color }}>adicionar {projectCount} projeto(s)</strong> à análise atual?
                                <br /><br />
                                Esta ação irá recalcular todos os resultados incluindo os projetos selecionados.
                            </>
                        )}
                        <br /><br />
                        <strong>Confirmar operação?</strong>
                    </p>
                </div>

                {/* Action buttons */}
                <div style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                    <Button
                        variant="secondary"
                        onClick={onHide}
                        disabled={loading}
                        style={{
                            backgroundColor: '#6c757d',
                            borderColor: '#6c757d',
                            padding: '10px 30px',
                            fontWeight: 'bold',
                            borderRadius: '8px',
                            minWidth: '100px'
                        }}
                    >
                        Cancelar
                    </Button>

                    <Button
                        variant={isRemove ? "danger" : "success"}
                        onClick={handleConfirm}
                        disabled={loading}
                        style={{
                            backgroundColor: color,
                            borderColor: color,
                            padding: '10px 30px',
                            fontWeight: 'bold',
                            borderRadius: '8px',
                            minWidth: '120px'
                        }}
                    >
                        {loading ? 'Processando...' : actionCapitalized}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ProjectConfirmModal;